
import  React from "react"
import { Modal, Button, List, Spin } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import PropTypes from "prop-types" // Import PropTypes
import { useEffect, useState } from "react"
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { getConsultantMedicinesData } from '../../../services/doctor/consultant/consultant';

const MedicineViewModal = ({isOpen, onClose, patientData}) => {

  const [loading, setLoading] = useState(false);
  const [consultantMedicines, setConsultantMedicines] = useState([]);

  const fetchConsultantMedicines = async () => {
    try
    {
      setLoading(true);

      const result = await getConsultantMedicinesData(patientData?.id);

      if( result.success)
      {
        setConsultantMedicines(result.data);
        setLoading(false);
      }
      else
      {
        // Optionally handle error
        setConsultantMedicines([]);
      }
    }
    catch (err)
    {
      setLoading(false);
      // Optionally handle error
    }
  };
    
  useEffect(()=>{
    if( isOpen )
    {
      fetchConsultantMedicines();
    }
  },[isOpen]);

  return (
    <>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#1890ff",
              margin: "-20px -24px 20px",
              padding: "10px 24px",
              color: "white",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Medicine List:-</span> <span className="mx-2">{patientData?.patient?.full_name}</span>
            </div>
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} style={{ color: "white" }} />
          </div>
        }
        open={isOpen}
        onCancel={onClose}
        maskClosable={false} 
        keyboard={false}
        footer={null}
        width={1200}
        styles={{ padding: "0 24px 24px" }}
        closable={false}
        centered
      >
        {loading ? (
          <div className="w-100 p-4 d-flex align-items-center justify-content-center">
            <Spin size="large" />
          </div>
        ) : (
          <>
            {/* Medicines Table */}
            {consultantMedicines && (
              <div className="diagnosis-section ">
                <div
                  className="table-responsive "
                  style={{
                    overflowX: "auto",
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  <div className="">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th
                            style={{
                              width: "4%",
                              textAlign: "center",
                            }}
                          >
                            <strong>Rx</strong>
                          </th>
                          <th style={{ width: "26%" }}>
                            <strong>નામ</strong>
                          </th>
                          <th style={{ width: "17%" }}>
                            <strong>આવર્તન</strong>
                          </th>
                          <th style={{ width: "15%" }}>
                            <strong>સમયગાળો</strong>
                          </th>
                          <th style={{ width: "28%" }}>
                            <strong>નોંધ</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {consultantMedicines?.map((med, idx) =>
                          med.doses?.map((dose, doseIdx) => (
                            <tr key={`${med.id}-${doseIdx}`}>
                              {doseIdx === 0 && (
                                <td
                                  rowSpan={med.doses.length}
                                  className="text-center"
                                >
                                  {idx + 1}
                                </td>
                              )}
                              {doseIdx === 0 && (
                                <td rowSpan={med.doses.length}>
                                  {med?.doses[0].type}{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {med?.medicine_name}
                                  </span>
                                </td>
                              )}
                              <td>
                                {dose?.type_unit_ui == "Default" &&
                                dose?.default_timing_instruction ? (
                                  <>
                                    {(() => {
                                      const { Breakfast, Lunch, Dinner } =
                                        dose.default_timing_instruction || {};
                                      const q = dose.quantity || 0;
                                      const breakfastDose = Breakfast ? q : 0;
                                      const lunchDose = Lunch ? q : 0;
                                      const dinnerDose = Dinner ? q : 0;
                                      const unitString =
                                        dose?.type &&
                                        !["Tablet", "Capsule"].includes(
                                          dose.type
                                        )
                                          ? ` ${dose?.unit || ""}`
                                          : "";

                                      const dosageResult = `${breakfastDose}${unitString} - ${lunchDose}${unitString} - ${dinnerDose}${unitString}`.trim();

                                      // Check if index is not 0 (Note: Ensure 'index' is available from your .map() scope)
                                      return (
                                        <span>
                                          {doseIdx !== 0 ? (
                                            <>
                                              <u>Then</u> {dosageResult}
                                            </>
                                          ) : (
                                            dosageResult
                                          )}
                                        </span>
                                      );
                                    })()}
                                    <br />
                                  </>
                                ) : dose?.type_unit_ui == "Alternate" &&
                                  dose?.default_timing_instruction ? (
                                  <>
                                    {(() => {
                                      const timingKeys = Object.keys(
                                        dose?.default_timing_instruction || {}
                                      );
                                      const key = timingKeys[0]; // Assume we only care about the first key if multiple exist
                                      let dosageResult = ""; // Initialize a variable to hold our text

                                      // 2. Check for the specific frequency keys (in English) and return the corresponding Gujarati text
                                      if (key === "Once") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દિવસ માં ૧ વાર `; // Once a day
                                      }
                                      else if (key === "Twice") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દિવસ માં ૨ વાર`; // Twice a day
                                      }
                                      else if (key === "Thrice") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દિવસ માં ૩ વાર`; // Thrice a day
                                      }
                                      else if (key === "4h") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દર ૪ કલાકે`; // Every 4 hours
                                      }
                                      else if (key === "6h") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દર ૬ કલાકે`; // Every 6 hours
                                      }
                                      else if (key === "8h") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દર ૮ કલાકે`; // Every 8 hours
                                      }
                                      else if (key === "12h") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દર ૧૨ કલાકે`; // Every 12 hours
                                      }
                                      else if (key === "48h") {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} દર ૨ દિવસે`; // Every 48 hours
                                      }
                                      else
                                      {
                                        dosageResult = `${dose?.quantity} ${dose?.unit} ${key}`; // Default to the key if no match found
                                      }

                                      // 2. Single return statement that handles the "Then" logic
                                      return (
                                        <span>
                                          {doseIdx !== 0 ? (
                                            <>
                                              <u>Then</u> {dosageResult}
                                            </>
                                          ) : (
                                            dosageResult
                                          )}
                                        </span>
                                      );
                                    })()}
                                  </>
                                ) : (
                                  <>
                                    {dose?.quantity} {dose?.unit}
                                  </>
                                )}
                              </td>
                              <td>
                                {(() => {
                                  const duration =
                                    dose.duration?.toLowerCase() || "";

                                  if (
                                    duration.includes("d") ||
                                    duration.includes("day")
                                  ) {
                                    const num = duration.match(/\d+/)?.[0];
                                    return num ? `${num} દિવસ` : "1 દિવસ";
                                  } else if (
                                    duration.includes("w") ||
                                    duration.includes("week")
                                  ) {
                                    const num = duration.match(/\d+/)?.[0];
                                    return num
                                      ? `${num} અઠવાડિયા`
                                      : "1 અઠવાડિયા";
                                  } else if (
                                    duration.includes("m") ||
                                    duration.includes("month")
                                  ) {
                                    const num = duration.match(/\d+/)?.[0];
                                    return num ? `${num} મહિના` : "1 મહિના";
                                  } else {
                                    return dose.duration || "N/A";
                                  }
                                })()}
                              </td>

                              <td>
                                {dose?.type_unit_ui === "Default" // Changed == to the stricter ===
                                  ? (() => {
                                      const { Breakfast, Lunch, Dinner } =
                                        dose.default_timing_instruction || {};

                                      let timingParts = [];

                                      // Logic for Breakfast
                                      if (Breakfast) {
                                        timingParts.push(
                                          Breakfast === "Before"
                                            ? "નાસ્તા પહેલા"
                                            : "નાસ્તા પછી"
                                        );
                                      }

                                      // Logic for Lunch
                                      if (Lunch) {
                                        timingParts.push(
                                          Lunch === "Before"
                                            ? "બપોરે ભોજન પહેલા"
                                            : "બપોરે ભોજન પછી"
                                        );
                                      }

                                      // Logic for Dinner
                                      if (Dinner) {
                                        timingParts.push(
                                          Dinner === "Before"
                                            ? "રાત્રી ભોજન પહેલા"
                                            : "રાત્રી ભોજન પછી"
                                        );
                                      }

                                      const timingString =
                                        timingParts.join(", "); // Joins all parts with a comma and space

                                      // Combine timing and note.
                                      return (
                                        timingString +
                                        (dose.note ? `, ${dose.note}` : "")
                                      );
                                    })()
                                  : (() => {
                                      const timingValues = Object.values(
                                        dose?.default_timing_instruction || {}
                                      );
                                      const firstValue = timingValues[0];
                                      let timing = "";

                                      // Use if/else if for efficient and clear condition checking
                                      if (firstValue === "Before Food") {
                                        timing = "ભોજન પહેલા";
                                      } else if (
                                        firstValue === "After Food"
                                      ) {
                                        timing = "ભોજન પછી";
                                      } else if (firstValue === "With Food") {
                                        timing = "ભોજન સાથે";
                                      } else if (
                                        firstValue === "Empty Stomach"
                                      ) {
                                        timing = "ભૂખ્યા પેટે";
                                      } else if (firstValue === "Bedtime") {
                                        timing = "સુવા ના સમયે";
                                      } else {
                                        // Default case if the value is not recognized (optional)
                                        // You can set timing = firstValue or keep it empty
                                      }

                                      // Combine timing and note without unnecessary comma handling
                                      return (
                                        timing +
                                        (dose.note && timing
                                          ? `, ${dose.note}`
                                          : dose.note || "")
                                      );
                                    })()}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        
      </Modal>
    </>
  )
}
MedicineViewModal.propTypes = {
    isOpen: PropTypes.bool.isRequired, // isOpen must be a boolean and is required
    onClose: PropTypes.func.isRequired, // onClose must be a function and is required
    patientData: PropTypes.patientData,
  }

export default MedicineViewModal
